// components/molecules/NoteEditor/TabPanel.tsx
import React from 'react';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

export const TabPanel: React.FunctionComponent<TabPanelProps> = function ({
    children,
    value,
    index,
}) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
        >
            {value === index && children}
        </div>
    );
};
